export default {
    paymentsList: {
        actions: 'Actions',
        allTab: 'Tous',
        amount: 'Montant',
        bulkAction: 'Actions de masse',
        contact: 'Contact',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression de paiement',
            message: 'Voulez-vous vraiment supprimer ce paiement?',
        },
        errors: {
            deleting: "Une erreur s'est produite lors de la suppression du paiement. | Une erreur s'est produite lors de la suppression des paiements.",
        },
        noPayments: 'Aucun paiement.',
        number: 'Numéro de facture',
        pageTitle: 'Paiements',
        received: 'Reçu',
        receivedTab: 'Reçus',
        sendPaymentLink: 'Envoyer le lien de paiement',
        sentOn: 'Envoyé le',
        status: 'Statut',
        statuses: {
            sent: 'Envoyé',
            seen: 'Visionné',
            paid: 'Payé',
            expired: 'Expiré',
            notSent: 'Non envoyé',
        },
        successes: {
            deleted: 'Paiement supprimé avec succès. | Paiements supprimés avec succès.',
        },
        tooltips: {
            deletePaidNotAllowed: 'Un paiement reçu ne peut pas être supprimé.',
            updateSeenNotAllowed: 'Un lien de paiement visionné ne peut pas être modifié.',
        },
        pendingTab: 'En attente',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter un?',
    },
    paymentModal: {
        amount: 'Montant',
        contact: 'Contact',
        notifications: {
            error: {
                send: 'Une erreur s\'est produite lors de l\'envoi du lien de paiement.',
                create: 'Une erreur s\'est produite lors de la création du paiement.',
                update: 'Une erreur s\'est produite lors de la modification du paiement.',
                uploadingFile: 'Une erreur s\'est produite lors du téléversement du fichier.',
            },
            success: {
                create: 'Paiement créé avec succès.',
                update: 'Paiement modifié avec succès.',
            },
        },
        paymentDetails: 'Détails du paiement',
        promptSendPaymentLinkModal: {
            header: 'Envoi du lien de paiement',
            message: 'Voulez-vous envoyer le lien de paiement au contact maintenant? Une nouvelle fenêtre vous permettra de saisir un message personnalisé.',
        },
        message: 'Message',
        invoiceNumber: 'Numéro de facture',
        title: {
            create: 'Créer un paiement',
            edit: 'Modifier un paiement',
        },
    },
    sendPaymentLinkModal: {
        title: 'Envoyer un lien de paiement',
        notifications: {
            error: {
                send: "Une erreur est survenue lors de l'envoi du lien de paiement.",
            },
            success: {
                send: 'Lien de paiement envoyé avec succès.',
            },
        },
    },
};
